import React from "react";
import ExternalLinkButton from "../ui/ExternalLinkButton";

const WidgetCard = ({
  text,
  Icon,
  path,
  desc,
  accent = "teal",
  cta = "Open",
  external = false,
}) => {
  const accentClass = `accent-${accent}`;

  return (
    <ExternalLinkButton
      to={path}
      className="widget-card-link group"
      external={external}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <div className={`widget-card-surface ${accentClass}`}>
        <div className="widget-card-accent-bar" />
        <div className="widget-card-body">
          <div className="widget-card-icon-wrap">
            {Icon ? (
              <Icon
                className="widget-card-icon"
                size={22}
                strokeWidth={1.75}
                aria-hidden="true"
              />
            ) : null}
          </div>
          <h3 className="widget-card-title">{text}</h3>
          <p className="widget-card-desc">{desc}</p>
          <div className="widget-card-cta">
            <span>{cta}</span>
            <svg
              className="widget-card-cta-arrow"
              viewBox="0 0 16 16"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2 8h11M9 4l4 4-4 4"
              />
            </svg>
          </div>
        </div>
      </div>
    </ExternalLinkButton>
  );
};

export default WidgetCard;
